var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[(_vm.$store.getters.getIsAdminRights === 'admin')?_c('ProformCategoryTableAdmin',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams},on:{"showMore":_vm.showMore,"changeFilter":_vm.changeFilter,"resetFilter":_vm.resetFilter,"updateTable":_vm.filter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }